import { ToggleButton, ToggleButtonProps } from 'components'
import { useCurrentUser } from 'components/providers'
import { startCase } from 'lodash-es'
import { EntevatePermission } from 'types'
import { useEntevatePermission } from 'utils'

interface Props
  extends Omit<ToggleButtonProps<EntevatePermission>, 'options' | 'value' | 'onChange'> {}

export default function EntevatePermissionToggle(props: Props) {
  const [entevatePermission, setEntevatePermission] = useEntevatePermission()
  const user = useCurrentUser()

  if (!user?.isAdmin || !entevatePermission) return null

  return (
    <ToggleButton
      label="Permission"
      options={entevatePermissions.map(permission => ({
        value: permission,
        label: startCase(permission),
      }))}
      value={entevatePermission}
      onChange={setEntevatePermission}
      {...props}
    />
  )
}

export const entevatePermissions: EntevatePermission[] = ['entevate', 'admin', 'editor', 'viewer']
